module.exports = __webpack_public_path__ + "img/tick-tick-boom.58e4d49f.png";